<template>
  <v-card flat
          class="results results-superbet"
          light>
    <v-subheader class="results-title title red white--text pa-0">
      <div class="title-text pa-2">
        {{translations.roundResultsTitle}}
      </div>
    </v-subheader>
    <div class="results-items">
      <v-expansion-panel>
        <v-expansion-panel-content hide-actions
                                   class="results-item"
                                   :key="item.id"
                                   v-for="item in items">
          <template v-slot:header>
            <v-layout row
                      wrap
                      class="item-title">
              <v-flex xs6
                      class="text-xs-left item-title-text">
                <span>{{translations.roundTitle}} </span>
                <span>{{item.displayId}}</span>
              </v-flex>
              <v-flex xs6
                      class="text-xs-right">
                <span>{{formatRoundDate(item.createdAt)}}</span>
              </v-flex>
            </v-layout>
          </template>
          <v-card flat>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-layout row
                        wrap>
                <v-flex xs5
                        class="text-xs-center">
                  <div class="pa-3">
                    <div class="item-title-text">{{translations.winningNumberTitle}}</div>
                    <v-card flat
                            :color="itemResultColor(item)"
                            width="72"
                            height="72"
                            class="mt-3 mx-auto display-1 item-number">
                      <div class="pt-3 white--text">
                        {{item.result}}
                      </div>
                    </v-card>
                  </div>
                </v-flex>
                <v-divider vertical
                           xs1>
                </v-divider>
                <v-flex xs6
                        class="text-xs-left">
                  <div class="pa-3">
                    <div>{{translations.winningBetsTitle}}</div>
                    <div class="mt-3 caption">
                      <div :key="bet.name"
                           v-for="bet in itemWinningBets(item)">
                        {{bet.title}}
                      </div>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-divider></v-divider>
    </div>
  </v-card>
</template>

<script>
import Results from './Results';

export default {
  name: 'Results',
  extends: Results,
  methods: {
    notifyLoaded() {
      if (window.parentIFrame) {
        window.parentIFrame.sendMessage({
          type: 'contentLoaded',
        });
      }
    },
  },
  mounted() {
    if (window.parentIFrame) {
      this.notifyLoaded();
    } else {
      setTimeout(() => {
        this.notifyLoaded();
      }, 5000);
    }
  },
};
</script>

<style lang="scss">
.results-superbet {
  .v-expansion-panel {
    box-shadow: none;
  }

  .results-title {
    background-image: url("../assets/results-background.superbet.png");
    background-repeat: repeat-x;
    height: 42px;

    .title-text {
      background-image: url("../assets/results-texture.superbet.png");
      background-repeat: no-repeat;
      background-position: left top;
      width: 100%;
      height: 100%;
      line-height: 26px;
      text-transform: uppercase;
      font-style: italic;
      font-weight: 700;
      font-size: 16px;
    }
  }

  .results-item {
    color: #4a4a4a;

    .v-expansion-panel__header {
      padding: 5px 10px;
      min-height: 23px;
      background: #ececec;
      font-size: 12px;
      cursor: pointer;
    }

    .item-title-text {
      font-weight: 700;
    }

    .item-number {
      border-radius: 4px;
    }
  }
}
</style>
